import { TextFieldSizeEnum } from "../../../../enums/textFieldSizeEnum";
import { M_InputTextField, M_Select } from "../../../../M_Components";
import { useTranslation } from "react-i18next";

const TextForm = ({ propertyChangeCallback, field, errors, canEdit }) => {
    const [t, i18n] = useTranslation();
    const textFieldSizeEnum = Object.keys(TextFieldSizeEnum);

    const handleChange = (property, value) => {
        propertyChangeCallback(property, value)
    }

    return (
        <>
            <div className="field-one-columns" >
                <M_InputTextField
                    label={t("NgeDefaultValue")}
                    value={field.defaultValue ?? ""}
                    onChange={(e) => handleChange("defaultValue", e.target.value)}
                    disabled={!canEdit}
                    color={errors["defaultValue"] === null ? null : 'var(--color-red)'}
                    helperTextMessage={errors['defaultValue']}
                />
            </div>
            <div className="field-one-columns">
                <M_Select
                    label={t("NgeSize")}
                    value={field.textSize ?? ""}
                    options={textFieldSizeEnum.map(el => ({
                        label: `${t(el)} (${TextFieldSizeEnum[el]})`,
                        value: el
                    })
                    )}
                    disabled={!canEdit}
                    noNone
                    required
                    onChange={(e) => handleChange("textSize", e.target.value)}

                />
            </div>
        </>
    )

}

export default TextForm;
